import React from "react";
import { Navigate, RouteObject } from "react-router-dom";

import { GLOBAL_STYLES_ROUTES, WIDGET_ROUTES } from "../../routes";

export const WidgetLibraryRoutes: RouteObject[] = [
  {
    path: GLOBAL_STYLES_ROUTES.GlobalStyles_Experiences,
    lazy: async () => {
      const { WidgetLibraryRoute } = await import(
        "../../../domains/WidgetLibrary/WidgetLibrary.route"
      );
      const { ScopedRoute } = await import(
        "@src/components/LimitAccess/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            isEnabled={(org) => true}
            debugId={GLOBAL_STYLES_ROUTES.GlobalStyles_Experiences}
            children={WidgetLibraryRoute}
          />
        ),
      };
    },
  },
  {
    path: GLOBAL_STYLES_ROUTES.GlobalStyles_Sitewide,
    lazy: async () => {
      const { WidgetLibraryRoute } = await import(
        "../../../domains/WidgetLibrary/WidgetLibrary.route"
      );
      const { ScopedRoute } = await import(
        "@src/components/LimitAccess/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            isEnabled={(org) => true}
            debugId={GLOBAL_STYLES_ROUTES.GlobalStyles_Sitewide}
            children={WidgetLibraryRoute}
          />
        ),
      };
    },
  },
  // Redirects from old widget-library paths to new global-styles paths
  {
    path: WIDGET_ROUTES.WidgetLibrary_Experiences,
    element: (
      <Navigate to={GLOBAL_STYLES_ROUTES.GlobalStyles_Experiences} replace />
    ),
  },
  {
    path: WIDGET_ROUTES.WidgetLibrary_Sitewide,
    element: (
      <Navigate to={GLOBAL_STYLES_ROUTES.GlobalStyles_Sitewide} replace />
    ),
  },
];
